import { render, staticRenderFns } from "./DueList.vue?vue&type=template&id=1318c533&scoped=true"
import script from "./DueList.vue?vue&type=script&lang=js"
export * from "./DueList.vue?vue&type=script&lang=js"
import style0 from "./DueList.vue?vue&type=style&index=0&id=1318c533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318c533",
  null
  
)

export default component.exports